import { useRef, ReactNode } from 'react';
import { Dialog, DialogTitle, Paper, type DialogProps } from '@mui/material';
import Draggable from 'react-draggable';

function DraggablePaper(props: any) {
  const { titleId, ...rest } = props;
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    // @ts-expect-error react-draggable types lag behind React 19
    <Draggable nodeRef={nodeRef} handle={`#${titleId}`} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper ref={nodeRef} {...rest} />
    </Draggable>
  );
}

interface DraggableDialogProps extends Omit<DialogProps, 'title' | 'onClose'> {
  title: ReactNode;
  titleId?: string;
  onClose: () => void;
  children: ReactNode;
}

export default function DraggableDialog({
  title, titleId = 'dialog-title', children, onClose, ...dialogProps
}: DraggableDialogProps) {
  const handleClose = (_event: unknown, reason: string) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Dialog
      {...dialogProps}
      onClose={handleClose}
      PaperComponent={DraggablePaper}
      aria-labelledby={titleId}
      slotProps={{ paper: { titleId } as any }}
    >
      <DialogTitle id={titleId} sx={{ cursor: 'grab', userSelect: 'none' }}>{title}</DialogTitle>
      {children}
    </Dialog>
  );
}
